

let timerInterval = null;

export const state = () => ({
  otp: {
    isOtpTimeout: false,
    otpTimer: 0,
    isLoading: false,
    isInvalidOtp: false,
    redirectRoute: null,
    callbackFunc: null,
    method: null,
    phone: null,
    triggerOnly: false,
    isOtpRequested: false,
    currentNumberValid: false,
  },
});

const initialState = state();
export const getters = {
  getOTPState(state) {
    return state.otp;
  },
};


export const mutations = {
  setOtpMethod(state, method) {
    state.otp = {
      ...state.otp,
      method,
    };
  },
  setInvalidOtp(state, isInvalidOtp) {
    state.otp = {
      ...state.otp,
      isInvalidOtp,
    };
  },
  setLoading(state, isLoading) {
    state.otp = {
      ...state.otp,
      isLoading,
    };
  },
  setOtpTimer(state, otpTimer) {
    state.otp = {
      ...state.otp,
      otpTimer,
    };
  },
  setOtpTimeout(state, isOtpTimeout) {
    state.otp = {
      ...state.otp,
      isOtpTimeout,
    };
  },
  clearOtpFlow(state) {
    state.otp = {
      ...initialState.otp,
      redirectRoute: state.redirectRoute,
      callbackFunc: state.callbackFunc,
      method: state.method,
      phone: state.phone,
      triggerOnly: state.triggerOnly,
    };
  },
  setRedirectRoute(state, route) {
    state.otp = {
      ...state.otp,
      redirectRoute: route,
    };
  },
  setCallbackFunc(state, callbackFunc) {
    state.otp = {
      ...state.otp,
      callbackFunc,
    };
  },
  setOtpOptions(state, options) {
    state.otp = {
      ...state.otp,
      ...options,
    };
  },
  resetOtpState(state) {
    state.otp = JSON.parse(JSON.stringify(initialState.otp));
  },
  setOtpRequestState(state, isOtpRequested) {
    state.otp = {
      ...state.otp,
      isOtpRequested,
    };
  },
  setCurrentNumberValidation(state, val) {
    state.otp = {
      ...state.otp,
      currentNumberValid: val,
    };
  },
};

export const actions = {
  startOtpTimer({ commit, dispatch }, defaultTimer = 60) {
    let timer = defaultTimer > 0 ? defaultTimer : 60;
    clearInterval(timerInterval);
    setTimeout(() => {
      commit('setOtpTimeout', false);
    }, 1100);
    timerInterval = setInterval(() => {
      timer -= 1;
      commit('setOtpTimer', timer);
      if (timer <= 0) {
        commit('setLoading', false);
        dispatch('otpTimeout');
      }
    }, 1000);
  },

  startOtp({ commit, dispatch }, payload) {
    const { method, timer } = payload;
    commit('setOtpMethod', method);
    commit('setOtpRequestState', true);
    dispatch('setOtpValidationState', false);
    dispatch('startOtpTimer', timer);
  },

  setOtpValidationState({ commit }, payload) {
    commit('setInvalidOtp', payload);
    commit('setLoading', false);
  },

  setOtpLoadingState({ commit }, payload) {
    commit('setLoading', payload);
  },

  stopOtpTimer({ commit }) {
    clearInterval(timerInterval);
    commit('setOtpTimer', 0);
  },

  otpTimeout({ commit, dispatch }) {
    dispatch('stopOtpTimer');
    commit('setOtpTimeout', true);
  },

  clearOtpFlow({ commit, dispatch }) {
    dispatch('stopOtpTimer');
    dispatch('hideOtpModal');
    commit('clearOtpFlow');
  },

  resetOtpState({ commit }) {
    commit('resetOtpState');
  },
};

